import styled from 'styled-components'

export const Container = styled.div`
  background: white;
  border-radius: 8px;
  padding: 24px;
  max-width: 900px;
  width: 100%;
  max-height: 90vh;
  overflow-y: auto;
  position: relative;
  z-index: 1000;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);
  font-family: 'Inter', sans-serif;
`

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 24px;
`

export const TitleRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;

  h2 {
    font-size: 18px;
    font-weight: 600;
    color: #262626;
    margin: 0;
  }
`

export const CloseButton = styled.button`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border: none;
  background: #f4f4f4;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: 0;
  flex-shrink: 0;
  transition: background-color 0.2s ease;

  &:hover {
    background: #e8e8e8;
  }

  svg {
    color: #595959;
  }
`

export const InfosContainer = styled.div`
  margin-bottom: 24px;
`

export const Section = styled.div`
  margin-bottom: 0;
  background: transparent;
  padding: 0;

  &:last-child {
    margin-bottom: 0;
  }
`

export const SectionDivider = styled.div`
  height: 1px;
  background-color: #F0F0F0;
  margin: 24px 0;
`

export const SectionSubtitle = styled.h3`
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 12px;
  color: #262626;
  padding: 0;
`

export const InfoGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;
  background: transparent;
  padding: 0;
`

export const InfoItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`

export const InfoLabel = styled.span`
  font-size: 12px;
  color: #8C8C8C;
  font-weight: 400;
`

export const InfoValue = styled.span`
  font-size: 14px;
  color: #262626;
  font-weight: 600;
`

export const TextBlock = styled.div`
  background: #FAFAFA;
  border-radius: 6px;
  padding: 12px 16px;
  font-size: 14px;
  color: #262626;
  line-height: 1.6;
  white-space: pre-wrap;
  word-break: break-word;
`

export const TextBlockLabel = styled.span`
  font-size: 12px;
  color: #8C8C8C;
  font-weight: 400;
  margin-bottom: 6px;
  display: block;
`

export const SimpleTable = styled.table`
  width: 100%;
  border-collapse: collapse;
`

export const SimpleTableRow = styled.tr``

export const TableHeader = styled.th`
  text-align: left;
  padding: 8px 0;
  background-color: transparent;
  font-weight: 500;
  font-size: 12px;
  color: #8C8C8C;
  border-bottom: none;
`

export const TableCell = styled.td`
  padding: 12px 0;
  font-size: 14px;
  color: #262626;
`

export const RelevantBadge = styled.span<{ relevant: boolean }>`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 2px 10px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 600;
  background: ${({ relevant }) => relevant ? '#FFF1F0' : '#F6FFED'};
  color: ${({ relevant }) => relevant ? '#CF1322' : '#389E0D'};
`

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding-top: 16px;
`

export const ButtonDiv = styled.button<{ variant?: 'primary' | 'ghost' | 'outline' }>`
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 10px 16px;
  border-radius: 20px;
  font-size: 14px;
  font-weight: bold;
  cursor: pointer;
  border: none;
  white-space: nowrap;

  ${props => {
        switch (props.variant) {
            case 'primary':
                return `
          background-color: #00A8E8;
          color: white;
        `
            case 'outline':
                return `
          background-color: white;
          color: #00A8E8;
          border: 1px solid #00A8E8;
        `
            case 'ghost':
                return `
          background-color: transparent;
          color: #595959;
          border: 1px solid #D9D9D9;
        `
            default:
                return `
          background-color: #F5F5F5;
          color: #262626;
        `
        }
    }}
`
